import React from "react";

// retry_status arrives as an object (e.g. {type: "exhausted"}) from the Anthropic
// SDK, though older/string forms are possible — render a string either way so it
// can't reach React as a raw object.
function retryLabel(rs) {
  if (!rs) return null;
  if (typeof rs === "string") return rs;
  return rs.type || null;
}

export default function ErrorItem({ event }) {
  const p = event.payload || {};
  const retry = retryLabel(p.retry_status);
  return (
    <div className="ev ev--error">
      <strong>Error{p.error_type ? ` · ${p.error_type}` : ""}:</strong> {p.message || "unknown error"}
      {retry ? <em> ({retry})</em> : null}
    </div>
  );
}
